export default __webpack_public_path__ + "static/media/bg-tunangan.94cb1742.jpg";